import React from "react";
import { AppBar as AppBarReactAdmin, UserMenu } from "react-admin";

import LogoutMenuItem from "../LogoutMenuItem/LogoutMenuItem";

const AppBar: React.FC = () => (
  <AppBarReactAdmin
    sx={{
      backgroundColor: "#f08642",
    }}
    className="c-app-bar"
    userMenu={
      <UserMenu>
        <LogoutMenuItem />
      </UserMenu>
    }
  >
    <div style={{ flex: "1 1 auto" }}>
      <p>v1.3.0</p>
    </div>
  </AppBarReactAdmin>
);

export default AppBar;
